import CheckoutPage from "../components/templates/checkoutPage/CheckoutPage";

//checkoutPage
const Checkout = () => {
  return <CheckoutPage />;
};

export default Checkout;
